import Route from 'cio/routes/base';

export default class IndexRoute extends Route {
  model() {
    return this.modelFor('layout').reload();
  }
}
